import { Configuration } from "@/src/generated/api/src";

export const createClientApiConfiguration = () => {
  return new Configuration({
    basePath: process.env.NEXT_PUBLIC_API_URL ?? "/api",
    credentials: "include",
  });
};
